import React, { useEffect } from 'react';
import Article from '../../Components/Article';
import Slider from 'react-slick';
import './style.scss';
const settings = {
  centerMode: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  centerPadding: 0,
  dots: false,
  variableWidth: true,
  arrows: true,
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const ListPosts = ({ articlesPlatform }) => {
  return (
    <div className='post post-carousel'>
      <h4 className='post__title'>Bài đăng của doanh nghiệp</h4>
      <div style={{ position: 'relative', left: '0px' }}>
        <Slider {...settings}>
          {articlesPlatform &&
            articlesPlatform.map((article, index) => {
              if (index <= 1) {
                return '';
              }
              return <Article {...article} key={index} />;
            })}
        </Slider>
      </div>
    </div>
  );
};
export default ListPosts;
